<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ note && note.id ? 'Edit ' : 'Create ' }} Note</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="confirmChangeEmail">
          <div class="field">
            <div class="control">
              <textarea
                class="input"
                ref="updatedNote"
                placeholder="Add note"
                v-model="updatedNote"
                :disabled="isSavingNote"
              />
            </div>
          </div>

          <input type="submit" style="display: none" />
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="saveNoteError">
          {{ saveNoteError }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancelSaveNote" :disabled="isSavingNote">
              Cancel
            </button>
            <button
              class="button is-primary"
              @click="confirmSaveNote"
              :class="{ 'is-loading': isSavingNote }"
              :disabled="isSavingNote"
            >
              Save note
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { SAVE_NOTE } from './userStore'

export default {
  name: 'UserEditNoteModal',

  props: {
    note: {
      type: Object
    },

    userStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      updatedNote: null,
      isSavingNote: false,
      saveNoteError: null
    }
  },

  mounted() {
    this.$refs.updatedNote.focus()

    this.updatedNote = this.note ? this.note.note : null
  },

  methods: {
    cancelSaveNote() {
      this.$emit('cancelled')
    },

    async confirmSaveNote() {
      this.saveNoteError = null
      this.isSavingNote = true

      try {
        const saveNoteAction = `${this.userStorePath}/${SAVE_NOTE}`
        await this.$store.dispatch(saveNoteAction, {
          id: this.note ? this.note.id : null,
          note: this.updatedNote
        })

        this.$emit('succeeded')
      } catch (error) {
        this.saveNoteError = error || 'Something went wrong.'
      } finally {
        this.isSavingNote = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}

textarea {
  height: 200px;
}
</style>
